<div class="header">
  <h1 style="margin: 0">Редагування зомбі: <a routerLink="../">#{{zombie._id}}</a></h1>
  <span class="spacer"></span>
</div>

<div style="text-align: center; padding: 50px">
  <button mat-stroked-button color=accent (click)="connect()"><mat-icon>play_arrow</mat-icon> Start</button>
</div>
